export function getRandomNo(min,max){
    return Math.floor(Math.random() * (max-min+1)) + min;
}

export function validGameNFT(name){
    if(name!==undefined){
        if(name.startsWith("PANDA-")){
            return true;
        }
    }
    return false;
}